import styled from 'styled-components/native';
import {ColumnContainer, Header5, RowContainer} from '@styles/primitiveComponents';
import {colours, spacing} from '@styles/Style';
import {GetGlobalTheme} from '../../../Tools/DisplayTools';
import {isMobileOrTabletScreen, ScreenWidth} from '@tools/displayTools';

export const Container = styled(ColumnContainer)`
  background-color: ${colours[GetGlobalTheme()].white};
  width: ${isMobileOrTabletScreen() ? ScreenWidth() : 800}px;
  margin: ${isMobileOrTabletScreen() ? 0 : '250px auto'};
  height: ${isMobileOrTabletScreen() ? '96%' : 'initial'};
  border-top-left-radius: ${isMobileOrTabletScreen() ? spacing.space12 : 0};
  border-top-right-radius: ${isMobileOrTabletScreen() ? spacing.space12 : 0};
`;

export const HeaderText = styled(Header5)``;

export const CloseButton = {
  padding: '14px',
  marginLeft: 'auto',
  borderRadius: '8px',
};

export const MiddleContainer = styled(ColumnContainer)`
  padding: ${isMobileOrTabletScreen() ? spacing.space12 : spacing.space24}px;
  flex-grow: 1;
  background-color: ${isMobileOrTabletScreen() ? colours[GetGlobalTheme()].contentBG : colours[GetGlobalTheme()].white};
`;

export const CompanySection = styled(ColumnContainer)`
  gap: ${spacing.space12}px;
  border-radius: ${isMobileOrTabletScreen() ? spacing.space12 : 0}px;
  background-color: ${colours[GetGlobalTheme()].white};
  padding: ${isMobileOrTabletScreen() ? spacing.space24 : 0}px;
`;

export const CompanyContainer = styled(ColumnContainer)``;

export const SwitchAccountFooter = styled(RowContainer)`
  border-style: solid;
  border-width: 0;
  border-top-width: 1px;
  border-color: ${colours[GetGlobalTheme()].grey400};
  padding: ${spacing.space8}px ${spacing.space24}px;
  width: 100%;
  justify-content: end;
`;

export const ButtonWrapper = styled(RowContainer)`
  gap: ${spacing.space12};
  width: ${isMobileOrTabletScreen() ? '100%' : 'initial'};
`;

export const OpenButton = {
  backgroundColor: colours[GetGlobalTheme()].primary,
  padding: spacing.space24,
  flexGrow: isMobileOrTabletScreen() ? 1 : 0,
};

export const OpenButtonText = {
  color: colours[GetGlobalTheme()].white,
};

export const CancelButton = {
  backgroundColor: colours[GetGlobalTheme()].white,
  borderWidth: 1,
  borderColor: colours[GetGlobalTheme()].borderDefault,
  padding: spacing.space24,
  flexGrow: isMobileOrTabletScreen() ? 1 : 0,
};

export const CancelButtonText = {
  color: colours[GetGlobalTheme()].primary,
};

export const SearchBarWrapper = {
  padding: 0,
};

export const SearchIconStyle = {
  order: -1,
  marginRight: spacing.space8,
};

export const SearchBar = {
  backgroundColor: colours[GetGlobalTheme()].white,
  borderColor: colours[GetGlobalTheme()].borderDefault,
  borderRadius: 8,
  borderWidth: 1,
  margin: 0,
  padding: spacing.space12,
  paddingLeft: spacing.space32,
  width: '100%',
};
